import {Stack, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import Label from '../../../modules/customTable/Label'
import RangeChart from './RangeChart'
import {getVendorGatewayMeta} from '../../../constants/vendorGatewayLogos'

const FALLBACK_COLORS = ['#2D9CDB', '#003DA5', '#FF6B00', '#01C0F6', '#64748B', '#0688E7']

type TopPaymentMethod = {
  factory_name: string
  label?: string
  label_key?: string | null
  total: number
  count?: number
  percentage: number
}

type TopPaymentData = {
  methods?: TopPaymentMethod[]
  cash?: {total: number; percentage: number}
  online?: {total: number; percentage: number}
}

function resolveMethodColor(factoryName: string, index: number): string {
  const meta = getVendorGatewayMeta(factoryName)
  if (meta?.color) {
    return meta.color
  }
  if (factoryName === 'PY_CASH') {
    return '#01C0F6'
  }
  return FALLBACK_COLORS[index % FALLBACK_COLORS.length]
}

export default function TopPayment({data}: {data?: TopPaymentData}) {
  const {t} = useTranslation()
  const methods = data?.methods && Array.isArray(data.methods) ? data.methods : []

  const cash = data?.cash
  const online = data?.online
  const rows =
    methods.length > 0
      ? methods
      : [
          ...(cash && Number(cash.total) > 0
            ? [
                {
                  factory_name: 'PY_CASH',
                  label_key: 'cashOnDelivery',
                  total: Number(cash.total),
                  percentage: Number(cash.percentage),
                } as TopPaymentMethod,
              ]
            : []),
          ...(online && Number(online.total) > 0
            ? [
                {
                  factory_name: 'ONLINE',
                  label_key: 'onlinePayments',
                  total: Number(online.total),
                  percentage: Number(online.percentage),
                } as TopPaymentMethod,
              ]
            : []),
        ]

  return (
    <Stack
      height={'auto'}
      minHeight={'203px'}
      minWidth={{xlg: '350px', lg: 'auto'}}
      width={'100%'}
      gap='16px'
      borderRadius={'18px'}
      bgcolor={'#fff'}
      p='24px'
    >
      <Label color='#3F4254' text='topPayment' fs='18px' fw='500' />
      {rows.length === 0 ? (
        <Typography fontSize={13} color='#8D98AF'>
          {t('noPaymentDataForPeriod')}
        </Typography>
      ) : (
        rows.map((method, index) => (
          <RangeChart
            key={`${method.factory_name}-${index}`}
            color={resolveMethodColor(method.factory_name, index)}
            isCurrancy
            name={
              method.label_key ||
              getVendorGatewayMeta(method.factory_name)?.name ||
              method.label ||
              method.factory_name
            }
            num={Number(method.percentage) || 0}
            value={Number(method.total) || 0}
          />
        ))
      )}
    </Stack>
  )
}
